import React from "react";
import {
  styled,
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List
} from "@mui/material";

const StyledCheckbox = styled(Checkbox)(() => ({
  "& .MuiSvgIcon-root": {
    backgroundColor: "rgba(231, 231, 231, 1)"
  }
}));

const StyledList = styled(List)(() => ({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  height: "100%"
}));

export interface CheckInputInterface {
  options?: { label: string; isChecked: boolean }[];
  onChange: () => void;
}

const CheckboxInput = ({ options, onChange }: CheckInputInterface) => {
  return (
    <StyledList>
      {options &&
        options.map((item: any) => {
          return (
            <ListItem disablePadding>
              <ListItemButton role={undefined} onClick={onChange}>
                <ListItemIcon>
                  <StyledCheckbox
                    edge="start"
                    checked={item.isChecked}
                    color={"primary"}
                  />
                </ListItemIcon>
                <ListItemText id={item.label} primary={item.label} />
              </ListItemButton>
            </ListItem>
          );
        })}
    </StyledList>
  );
};

export default CheckboxInput;
